import { render, staticRenderFns } from "./resourceAddEditForm.vue?vue&type=template&id=df95b540&scoped=true&"
import script from "./resourceAddEditForm.vue?vue&type=script&lang=js&"
export * from "./resourceAddEditForm.vue?vue&type=script&lang=js&"
import style0 from "./resourceAddEditForm.vue?vue&type=style&index=0&id=df95b540&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df95b540",
  null
  
)

export default component.exports